 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A00_COVER from '@/components/000_Cover'
 import A01_HALFTITLE from '@/components/001_Halftitle'
 import A02_TITLE from '@/components/002_Title'
 import A03_COPYRIGHT from '@/components/003_Copyright'
 import A04_CONTENTS from '@/components/004_Contents'
 import A04A_LIST from '@/components/004a_List'
 import A05_FOREWORD from '@/components/005_Foreword'
 import A06_WORLD from '@/components/006_World'
 import A07_PLACES from '@/components/007_Places'
 import A08_HUMOUR from '@/components/008_Humour'
 import A09_PRINT from '@/components/009_Print'
 import A10_NEIL from '@/components/010_Neil'
 import A11_ACKNOWLEDGEMENTS from '@/components/011_Acknowledgements'
 import A12_PART01 from '@/components/012_Part01'
 import A13_CHAPTER01 from '@/components/013_Chapter01'
 import A14_CHAPTER02 from '@/components/014_Chapter02'
 import A15_CHAPTER03 from '@/components/015_Chapter03'
 import A16_CHAPTER04 from '@/components/016_Chapter04'
 import A17_CHAPTER05 from '@/components/017_Chapter05'
 import A18_CHAPTER06 from '@/components/018_Chapter06'
 import A19_CHAPTER07 from '@/components/019_Chapter07'
 import A20_CHAPTER08 from '@/components/020_Chapter08'
 import A21_CHAPTER09 from '@/components/021_Chapter09'
 import A22_CHAPTER10 from '@/components/022_Chapter10'
 import A23_CHAPTER11 from '@/components/023_Chapter11'
 import A24_CHAPTER12 from '@/components/024_Chapter12'
 import A25_PART02 from '@/components/025_Part02'
 import A26_CHAPTER13 from '@/components/026_Chapter13'
 import A27_CHAPTER14 from '@/components/027_Chapter14'
 import A28_CHAPTER15 from '@/components/028_Chapter15'
 import A29_PART03 from '@/components/029_Part03'
 import A30_CHAPTER16 from '@/components/030_Chapter16'
 import A31_CHAPTER17 from '@/components/031_Chapter17'
 import A32_CHAPTER18 from '@/components/032_Chapter18'
 import A33_CHAPTER19 from '@/components/033_Chapter19'
 import A34_PART04 from '@/components/034_Part04'
 import A35_CHAPTER20 from '@/components/035_Chapter20'
 import A36_CHAPTER21 from '@/components/036_Chapter21'
 import A37_CHAPTER22 from '@/components/037_Chapter22'
 import A38_CHAPTER23 from '@/components/038_Chapter23'
 import A39_CHAPTER24 from '@/components/039_Chapter24'
 import A40_CHAPTER25 from '@/components/040_Chapter25'
 import A41_PART05 from '@/components/041_Part05'
 import A42_CHAPTER26 from '@/components/042_Chapter26'
 import A43_CHAPTER27 from '@/components/043_Chapter27'
 import A44_CHAPTER28 from '@/components/044_Chapter28'
 import A45_CHAPTER29 from '@/components/045_Chapter29'
 import A46_CHAPTER30 from '@/components/046_Chapter30'
 import A47_CHAPTER31 from '@/components/047_Chapter31'
 import A48_CHAPTER32 from '@/components/048_Chapter32'
 import A49_CHAPTER33 from '@/components/049_Chapter33'
 import A50_CHAPTER34 from '@/components/050_Chapter34'
 import A51_CHAPTER35 from '@/components/051_Chapter35'
 import A52_CHAPTER36 from '@/components/052_Chapter36'
 import A53_CHAPTER37 from '@/components/053_Chapter37'
 import A54_CHAPTER38 from '@/components/054_Chapter38'
 import A55_PART06 from '@/components/055_Part06'
 import A56_CHAPTER39 from '@/components/056_Chapter39'
 import A57_CHAPTER40 from '@/components/057_Chapter40'
 import A58_CHAPTER41 from '@/components/058_Chapter41'
 import A59_CHAPTER42 from '@/components/059_Chapter42'
 import A60_CHAPTER43 from '@/components/060_Chapter43'
 import A61_CHAPTER44 from '@/components/061_Chapter44'
 import A62_CHAPTER45 from '@/components/062_Chapter45'
 import A63_CHAPTER46 from '@/components/063_Chapter46'
 import A64_CHAPTER47 from '@/components/064_Chapter47'
 import A65_CHAPTER48 from '@/components/065_Chapter48'
 import A66_CHAPTER49 from '@/components/066_Chapter49'
 import A67_CHAPTER50 from '@/components/067_Chapter50'
 import A68_CHAPTER51 from '@/components/068_Chapter51'
 import A69_PART07 from '@/components/069_Part07'
 import A70_CHAPTER52 from '@/components/070_Chapter52'
 import A71_CHAPTER53 from '@/components/071_Chapter53'
 import A72_CHAPTER54 from '@/components/072_Chapter54'
 import A73_CHAPTER55 from '@/components/073_Chapter55'
 import A74_CHAPTER56 from '@/components/074_Chapter56'
 import A75_CHAPTER57 from '@/components/075_Chapter57'
 import A76_CHAPTER58 from '@/components/076_Chapter58'
 import A77_CHAPTER59 from '@/components/077_Chapter59'
 import A78_CHAPTER60 from '@/components/078_Chapter60'
 import A79_CHAPTER61 from '@/components/079_Chapter61'
 import A80_CHAPTER62 from '@/components/080_Chapter62'
 import A81_CHAPTER63 from '@/components/081_Chapter63'
 import A82_CHAPTER64 from '@/components/082_Chapter64'
 import A83_CHAPTER65 from '@/components/083_Chapter65'
 import A84_CHAPTER66 from '@/components/084_Chapter66'
 import A85_CHAPTER67 from '@/components/085_Chapter67'
 import A86_CHAPTER68 from '@/components/086_Chapter68'
 import A87_CHAPTER69 from '@/components/087_Chapter69'
 import A88_CHAPTER70 from '@/components/088_Chapter70'
 import A89_CHAPTER71 from '@/components/089_Chapter71'
 import A90_CHAPTER72 from '@/components/090_Chapter72'
 import A91_CHAPTER73 from '@/components/091_Chapter73'
 import A92_CHAPTER74 from '@/components/092_Chapter74'
 import A93_CHAPTER75 from '@/components/093_Chapter75'
 import A94_CHAPTER76 from '@/components/094_Chapter76'
 import A95_CHAPTER77 from '@/components/095_Chapter77'
 import A96_PART08 from '@/components/096_Part08'
 import A97_CHAPTER78 from '@/components/097_Chapter78'
 import A98_CHAPTER79 from '@/components/098_Chapter79'
 import A99_CHAPTER80 from '@/components/099_Chapter80'
 import A00_CHAPTER81 from '@/components/100_Chapter81'
 import A01_PART09 from '@/components/101_Part09'
 import A02_CHAPTER82 from '@/components/102_Chapter82'
 import A03_CHAPTER83 from '@/components/103_Chapter83'
 import A04_CHAPTER84 from '@/components/104_Chapter84'
 import A05_CHAPTER85 from '@/components/105_Chapter85'
 import A06_CHAPTER86 from '@/components/106_Chapter86'
 import A07_CHAPTER87 from '@/components/107_Chapter87'
 import A08_CHAPTER88 from '@/components/108_Chapter88'
 import A09_CHAPTER89 from '@/components/109_Chapter89'
 import A10_CHAPTER90 from '@/components/110_Chapter90'
 import A11_CHAPTER91 from '@/components/111_Chapter91'
 import A12_CHAPTER92 from '@/components/112_Chapter92'
 import A13_CHAPTER93 from '@/components/113_Chapter93'
 import A14_CHAPTER94 from '@/components/114_Chapter94'
 import A15_CHAPTER95 from '@/components/115_Chapter95'
 import A16_CHAPTER96 from '@/components/116_Chapter96'
 import A17_CHAPTER97 from '@/components/117_Chapter97'
 import A18_CHAPTER98 from '@/components/118_Chapter98'
 import A19_CHAPTER99 from '@/components/119_Chapter99'
 import A20_CHAPTER100 from '@/components/120_Chapter100'
 import A21_NOTE from '@/components/121_Note'
 import A22_PLATES from '@/components/122_Plates'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/004_Contents",
 			"name" : "004_Contents",
 			"component" : A04_CONTENTS
 		},
 		{
 			"path" : "/004a_List",
 			"name" : "004a_List",
 			"component" : A04A_LIST
 		},
 		{
 			"path" : "/005_Foreword",
 			"name" : "005_Foreword",
 			"component" : A05_FOREWORD
 		},
 		{
 			"path" : "/006_World",
 			"name" : "006_World",
 			"component" : A06_WORLD
 		},
 		{
 			"path" : "/007_Places",
 			"name" : "007_Places",
 			"component" : A07_PLACES
 		},
 		{
 			"path" : "/008_Humour",
 			"name" : "008_Humour",
 			"component" : A08_HUMOUR
 		},
 		{
 			"path" : "/009_Print",
 			"name" : "009_Print",
 			"component" : A09_PRINT
 		},
 		{
 			"path" : "/010_Neil",
 			"name" : "010_Neil",
 			"component" : A10_NEIL
 		},
 		{
 			"path" : "/011_Acknowledgements",
 			"name" : "011_Acknowledgements",
 			"component" : A11_ACKNOWLEDGEMENTS
 		},
 		{
 			"path" : "/012_Part01",
 			"name" : "012_Part01",
 			"component" : A12_PART01
 		},
 		{
 			"path" : "/013_Chapter01",
 			"name" : "013_Chapter01",
 			"component" : A13_CHAPTER01
 		},
 		{
 			"path" : "/014_Chapter02",
 			"name" : "014_Chapter02",
 			"component" : A14_CHAPTER02
 		},
 		{
 			"path" : "/015_Chapter03",
 			"name" : "015_Chapter03",
 			"component" : A15_CHAPTER03
 		},
 		{
 			"path" : "/016_Chapter04",
 			"name" : "016_Chapter04",
 			"component" : A16_CHAPTER04
 		},
 		{
 			"path" : "/017_Chapter05",
 			"name" : "017_Chapter05",
 			"component" : A17_CHAPTER05
 		},
 		{
 			"path" : "/018_Chapter06",
 			"name" : "018_Chapter06",
 			"component" : A18_CHAPTER06
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js